"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const is_number_1 = require("../numbers/is-number");
const is_date_1 = require("../dates/is-date");
const is_missing_1 = require("../any/is-missing");
const validation_result_1 = require("./validation-result");
exports.VALIDATORS = {
    isDate: (property, value) => new validation_result_1.ValidationResult(is_date_1.isDate(value) ? [] : [{ message: `${property} must be a date. Got: ${value}` }]),
    isNumber: (property, value) => new validation_result_1.ValidationResult(is_number_1.isNumber(value) ? [] : [{ message: `${property} must be a number. Got: ${value}` }]),
    isDefined: (property, value) => new validation_result_1.ValidationResult(is_missing_1.isMissing(value) ? [{ message: `${property} must be defined. Got: ${value}` }] : []),
};
//# sourceMappingURL=validators.js.map